module.exports = __webpack_public_path__ + "static/media/Inter-ExtraLight.0713a6d4.woff";